// extracted by mini-css-extract-plugin
export default {"state":"divkit-b8efc","state__animations":"divkit-adaae","state__animation-child":"divkit-eb860","state__animation-child-inner":"divkit-e08c6"};